import { render, staticRenderFns } from "./grant-percent-stat.vue?vue&type=template&id=35ca6a43&scoped=true&"
import script from "./grant-percent-stat.vue?vue&type=script&lang=js&"
export * from "./grant-percent-stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ca6a43",
  null
  
)

export default component.exports